<template>
  <main class="index-page" :class="localeClass">
    <section ref="bannerRef" class="banner-block" :class="{ 'is-loaded': isInitialLoadingComplete }">
      <div class="banner-text">
        <div v-if="isInitialLoadingComplete" style="margin-right: -40px">
          <h5>
            {{ $t('index.onlinePoker') }}
          </h5>
        </div>
        <div v-if="isInitialLoadingComplete">
          <h1>POCKET POKER</h1>
        </div>
        <a v-if="isInitialLoadingComplete" href="#" class="default-red-link">{{ $t('index.explore') }}</a>
      </div>
    </section>
    <div class="section-wrapper">
      <section class="list-block">
        <div class="container">
          <div class="row">
            <div class="list-title">
              <div class="sunrise-reveal-mask">
                <h1 data-aos="sunrise-reveal" data-aos-delay="0" data-aos-offset="100" data-aos-duration="600">
                  {{ $t('index.welcomeTitle') }}
                </h1>
              </div>
              <div class="sunrise-reveal-mask">
                <p data-aos="sunrise-reveal" data-aos-delay="140" data-aos-offset="100" data-aos-duration="600">
                  {{ $t('index.welcomeDescription') }}
                </p>
              </div>
            </div>
            <div class="list-wrapper">
              <client-only>
                <swiper
                  class="feature-swiper"
                  :modules="modules"
                  :autoplay="{ delay: 3000, disableOnInteraction: false }"
                  :navigation="true"
                  :slides-per-view="1"
                  :space-between="20"
                  :loop="false"
                  :breakpoints="{
                    375: { slidesPerView: 2, spaceBetween: 20 },
                    768: { slidesPerView: 3, spaceBetween: 20 },
                    1024: { slidesPerView: 3, spaceBetween: 30 },
                    1200: { slidesPerView: 5, spaceBetween: 30 },
                  }"
                >
                  <swiper-slide>
                    <div
                      class="list-item"
                      data-aos="flip-left"
                      data-aos-delay="350"
                      data-aos-offset="100"
                      data-aos-duration="800"
                    >
                      <div class="list-item-img-wrapper">
                        <img src="@/assets/img/listItem01.png" alt="" />
                        <img src="@/assets/img/listItemBg01.png" alt="" />
                      </div>
                      <div class="list-item-text-wrapper">
                        <p>{{ $t('index.feature1Title') }}</p>
                        <p>{{ $t('index.feature1Description') }}</p>
                      </div>
                    </div>
                  </swiper-slide>
                  <swiper-slide>
                    <div
                      class="list-item"
                      data-aos="flip-left"
                      data-aos-delay="450"
                      data-aos-offset="100"
                      data-aos-duration="800"
                    >
                      <div class="list-item-img-wrapper">
                        <img src="@/assets/img/listItem02.png" alt="" />
                        <img src="@/assets/img/listItemBg01.png" alt="" />
                      </div>
                      <div class="list-item-text-wrapper">
                        <p>{{ $t('index.feature2Title') }}</p>
                        <p>{{ $t('index.feature2Description') }}</p>
                      </div>
                    </div>
                  </swiper-slide>
                  <swiper-slide>
                    <div
                      class="list-item"
                      data-aos="flip-left"
                      data-aos-delay="550"
                      data-aos-offset="100"
                      data-aos-duration="800"
                    >
                      <div class="list-item-img-wrapper">
                        <img src="@/assets/img/listItem03.png" alt="" />
                        <img src="@/assets/img/listItemBg01.png" alt="" />
                      </div>
                      <div class="list-item-text-wrapper">
                        <p>{{ $t('index.feature3Title') }}</p>
                        <p>{{ $t('index.feature3Description') }}</p>
                      </div>
                    </div>
                  </swiper-slide>
                  <swiper-slide>
                    <div
                      class="list-item"
                      data-aos="flip-left"
                      data-aos-delay="650"
                      data-aos-offset="100"
                      data-aos-duration="800"
                    >
                      <div class="list-item-img-wrapper">
                        <img src="@/assets/img/listItem04.png" alt="" />
                        <img src="@/assets/img/listItemBg01.png" alt="" />
                      </div>
                      <div class="list-item-text-wrapper">
                        <p>{{ $t('index.feature4Title') }}</p>
                        <p>{{ $t('index.feature4Description') }}</p>
                      </div>
                    </div>
                  </swiper-slide>
                  <swiper-slide>
                    <div
                      class="list-item"
                      data-aos="flip-left"
                      data-aos-delay="750"
                      data-aos-offset="100"
                      data-aos-duration="800"
                    >
                      <div class="list-item-img-wrapper">
                        <img src="@/assets/img/listItem05.png" alt="" />
                        <img src="@/assets/img/listItemBg01.png" alt="" />
                      </div>
                      <div class="list-item-text-wrapper">
                        <p>{{ $t('index.feature5Title') }}</p>
                        <p>{{ $t('index.feature5Description') }}</p>
                      </div>
                    </div>
                  </swiper-slide>
                </swiper>
              </client-only>
            </div>
          </div>
        </div>
      </section>
      <section class="bonus-block">
        <img src="@/assets/img/bonusBg.png" alt="" class="bonus-bg" />
        <img src="@/assets/img/light.png" alt="" class="light" />
        <!-- <div class="bonus-cards" aria-hidden="true">
          <img
            v-for="(placement, index) in bonusCardPlacements"
            :key="`bonus-card-${index}`"
            :src="pokerCardImages[index % pokerCardImages.length]"
            alt=""
            class="bonus-card"
            :style="bonusCardStyles[index]"
          />
        </div> -->
        <div class="bonus-content">
          <h2 data-aos="fade-in" data-aos-offset="100">{{ $t('index.bonusTitle') }}</h2>
          <p data-aos="fade-in" data-aos-offset="100" data-aos-delay="100">
            {{ $t('index.bonusDescription') }}
          </p>
          <div class="bonus-link-wrapper">
            <div data-aos="fade-in" data-aos-offset="100" class="bonus-link-animation">
              <a href="#" class="default-red-link">
                {{ $t('index.bonusLink') }}
              </a>
            </div>
          </div>
        </div>
      </section>
      <section ref="pokerBlockRef" class="poker-block">
        <div class="poker-sticky-container">
          <Transition name="poker-icon">
            <img
              v-if="visiblePokerSideIcons >= 1"
              src="@/assets/img/pokerIconBlack.png"
              alt=""
              class="poker-side-icon black-icon"
            />
          </Transition>
          <Transition name="poker-icon">
            <img
              v-if="visiblePokerSideIcons >= 3"
              src="@/assets/img/pokerIconDice.png"
              alt=""
              class="poker-side-icon dice-icon"
            />
          </Transition>
          <Transition name="poker-icon">
            <img
              v-if="visiblePokerSideIcons >= 2"
              src="@/assets/img/pokerIconMoney.png"
              alt=""
              class="poker-side-icon money-icon"
            />
          </Transition>
          <div class="poker-cards-wrapper">
            <img
              v-for="(imgSrc, index) in pokerCardImages"
              :key="index"
              :src="imgSrc"
              :alt="`Poker Card ${index + 1}`"
              class="poker-card"
              :class="{
                active: activeCardIndex === index + 1 || (index + 1 === 25 && activeCardIndex >= 25),
              }"
              :style="{ zIndex: index + 1 }"
            />
          </div>
        </div>
      </section>
    </div>
    <section ref="linkBlockRef" class="link-block">
      <img src="@/assets/img/ellipse.png" alt="" class="ellipse" />
      <img src="@/assets/img/ellipse02.png" alt="" class="ellipse-2" />
      <img
        src="@/assets/img/greenbox.png"
        alt=""
        class="greenbox"
        data-aos="greenbox-scale"
        data-aos-delay="150"
        data-aos-offset="100"
        data-aos-duration="800"
      />
      <div class="container">
        <div class="row">
          <client-only>
            <swiper
              :modules="modules"
              :slides-per-view="2"
              :space-between="20"
              :loop="false"
              :centered-slides="true"
              :centered-slides-bounds="true"
              :initial-slide="1"
              :center-insufficient-slides="true"
              :breakpoints="{
                375: { slidesPerView: 2, spaceBetween: 20 },
                768: { slidesPerView: 3, spaceBetween: 20 },
                1024: { slidesPerView: 3, spaceBetween: 30 },
                1200: { slidesPerView: 5, spaceBetween: 80 },
              }"
            >
              <swiper-slide>
                <div
                  class="list-item"
                  data-aos="flip-right"
                  data-aos-delay="0"
                  data-aos-offset="100"
                  data-aos-duration="800"
                >
                  <div class="list-item-img-wrapper">
                    <img src="@/assets/img/linkItem01.png" alt="" />
                  </div>
                  <div class="list-item-text-wrapper">
                    <p>{{ $t('index.link1Title') }}</p>
                    <a href="#" class="default-yellow-link default-yellow-link--shine">{{ $t('index.linkMore') }}</a>
                  </div>
                </div>
              </swiper-slide>
              <swiper-slide
                ><div
                  class="list-item"
                  data-aos="flip-right"
                  data-aos-delay="100"
                  data-aos-offset="100"
                  data-aos-duration="800"
                >
                  <div class="list-item-img-wrapper">
                    <img src="@/assets/img/linkItem02.png" alt="" />
                  </div>
                  <div class="list-item-text-wrapper">
                    <p>{{ $t('index.link2Title') }}</p>
                    <a href="#" class="default-yellow-link default-yellow-link--shine">{{ $t('index.linkMore') }}</a>
                  </div>
                </div>
              </swiper-slide>
              <swiper-slide
                ><div
                  class="list-item"
                  data-aos="flip-right"
                  data-aos-delay="200"
                  data-aos-offset="100"
                  data-aos-duration="800"
                >
                  <div class="list-item-img-wrapper">
                    <img src="@/assets/img/linkItem03.png" alt="" />
                  </div>
                  <div class="list-item-text-wrapper">
                    <p>{{ $t('index.link3Title') }}</p>
                    <a href="#" class="default-yellow-link default-yellow-link--shine">{{ $t('index.linkMore') }}</a>
                  </div>
                </div></swiper-slide
              >
            </swiper></client-only
          >
        </div>
      </div>
    </section>
    <section class="download-block">
      <div class="container">
        <div class="row slider-area">
          <div class="col-5 col-12-sm" data-aos="fade-right" data-aos-offset="100">
            <p class="white-text">{{ $t('index.downloadTitle') }}</p>
            <a href="#" class="default-red-link">{{ $t('index.downloadButton') }}</a>
            <img src="@/assets/img/downloadImg01.png" alt="" />
          </div>
          <div class="col-7 col-12-sm slider-swiper-wrapper" data-aos="fade-left" data-aos-offset="100">
            <div
              class="download-carousel"
              role="region"
              :aria-label="$t('index.downloadTitle')"
              @pointerdown="handleDownloadCarouselPointerDown"
              @pointermove="handleDownloadCarouselPointerMove"
              @pointerup="handleDownloadCarouselPointerUp"
              @pointercancel="handleDownloadCarouselPointerUp"
              @mouseenter="pauseDownloadCarousel"
              @mouseleave="resumeDownloadCarousel"
            >
              <div
                class="download-carousel-stage"
                :class="{ 'is-dragging': isDownloadCarouselDragging }"
                :style="{ transform: `translate3d(${downloadCarouselDragDistance * 0.35}px, 0, 0)` }"
              >
                <button
                  v-for="(slide, index) in downloadCarouselSlides"
                  :key="slide.id"
                  type="button"
                  class="download-carousel-slide"
                  :class="getDownloadCarouselSlideClass(index)"
                  :aria-label="`${slide.alt} ${index + 1}`"
                  @click.stop="handleDownloadCarouselSlideClick(index)"
                >
                  <img :src="slide.src" :alt="slide.alt" draggable="false" />
                </button>
              </div>

              <div
                class="download-carousel-pagination"
                aria-label="Carousel pagination"
                @pointerdown.stop
                @pointermove.stop
                @pointerup.stop
                @pointercancel.stop
              >
                <button
                  v-for="(slide, index) in downloadCarouselSlides"
                  :key="`pagination-${slide.id}`"
                  type="button"
                  class="download-carousel-dot"
                  :class="{ 'is-active': index === downloadCarouselActiveIndex }"
                  :aria-label="`${slide.alt} ${index + 1}`"
                  :aria-current="index === downloadCarouselActiveIndex ? 'true' : undefined"
                  @click.stop="setDownloadCarouselSlide(index)"
                />
              </div>
            </div>
          </div>
        </div>
        <div class="row list-area">
          <client-only>
            <swiper
              class="list-swiper"
              :modules="modules"
              :slides-per-view="2"
              :space-between="20"
              :loop="false"
              :centered-slides="true"
              :centered-slides-bounds="true"
              :initial-slide="1"
              :center-insufficient-slides="true"
              :breakpoints="{
                375: { slidesPerView: 2, spaceBetween: 20 },
                768: { slidesPerView: 3, spaceBetween: 20 },
                1024: { slidesPerView: 3, spaceBetween: 30 },
                1200: { slidesPerView: 5, spaceBetween: 80 },
              }"
            >
              <swiper-slide>
                <div
                  class="list-item"
                  data-aos="flip-left"
                  data-aos-delay="0"
                  data-aos-offset="100"
                  data-aos-duration="800"
                >
                  <div class="list-item-img-wrapper">
                    <img src="@/assets/img/downloadSwiper05.png" alt="" />
                    <img src="@/assets/img/downloadSwiper06.png" alt="" />
                  </div>
                  <div class="list-item-text-wrapper">
                    <p>{{ $t('index.downloadItem1Title') }}</p>
                    <p>{{ $t('index.downloadItem1Description') }}</p>
                  </div>
                </div>
              </swiper-slide>
              <swiper-slide
                ><div
                  class="list-item"
                  data-aos="flip-left"
                  data-aos-delay="100"
                  data-aos-offset="100"
                  data-aos-duration="800"
                >
                  <div class="list-item-img-wrapper">
                    <img src="@/assets/img/downloadSwiper03.png" alt="" />
                    <img src="@/assets/img/downloadSwiper06.png" alt="" />
                  </div>
                  <div class="list-item-text-wrapper">
                    <p>{{ $t('index.downloadItem2Title') }}</p>
                    <p>{{ $t('index.downloadItem2Description') }}</p>
                  </div>
                </div>
              </swiper-slide>
              <swiper-slide
                ><div
                  class="list-item"
                  data-aos="flip-left"
                  data-aos-delay="200"
                  data-aos-offset="100"
                  data-aos-duration="800"
                >
                  <div class="list-item-img-wrapper">
                    <img src="@/assets/img/downloadSwiper01.png" alt="" />
                    <img src="@/assets/img/downloadSwiper06.png" alt="" />
                  </div>
                  <div class="list-item-text-wrapper">
                    <p>{{ $t('index.downloadItem3Title') }}</p>
                    <p>{{ $t('index.downloadItem3Description') }}</p>
                  </div>
                </div>
              </swiper-slide>
            </swiper>
          </client-only>
        </div>
      </div>
    </section>
  </main>
</template>

<script setup lang="ts">
import { ref, computed, onMounted, onUnmounted } from 'vue';
// 匯入 Swiper 核心與模組
import { Swiper, SwiperSlide } from 'swiper/vue';
import { Navigation, Pagination, Autoplay } from 'swiper/modules';
import swiperItem from '@/assets/img/swiperItem.png';

const bannerRef = ref<HTMLElement | null>(null);
const isInitialLoadingComplete = useState('initial-loading-complete', () => false);
const { locale } = useI18n();
const localeClass = computed(() => `is-${locale.value}`);

// Download 區塊的自製卡片輪播
const downloadCarouselSlides = [
  { id: 1, src: swiperItem, alt: 'Slide 1' },
  { id: 2, src: swiperItem, alt: 'Slide 2' },
  { id: 3, src: swiperItem, alt: 'Slide 3' },
  { id: 4, src: swiperItem, alt: 'Slide 4' },
  { id: 5, src: swiperItem, alt: 'Slide 5' },
];
const downloadCarouselActiveIndex = ref(0);
const isDownloadCarouselDragging = ref(false);
const downloadCarouselDragDistance = ref(0);
const downloadCarouselDragStartX = ref(0);
const downloadCarouselDidDrag = ref(false);
let downloadCarouselAutoplayTimer: ReturnType<typeof setInterval> | null = null;

const normalizeDownloadCarouselIndex = (index: number) =>
  (index + downloadCarouselSlides.length) % downloadCarouselSlides.length;

const getDownloadCarouselSlideClass = (index: number) => {
  const totalSlides = downloadCarouselSlides.length;
  let offset = (index - downloadCarouselActiveIndex.value + totalSlides) % totalSlides;

  if (offset > Math.floor(totalSlides / 2)) {
    offset -= totalSlides;
  }

  return {
    'is-carousel-active': offset === 0,
    'is-carousel-left': offset === -1,
    'is-carousel-right': offset === 1,
    'is-carousel-far-left': offset < -1,
    'is-carousel-far-right': offset > 1,
  };
};

const stopDownloadCarouselAutoplay = () => {
  if (downloadCarouselAutoplayTimer) {
    clearInterval(downloadCarouselAutoplayTimer);
    downloadCarouselAutoplayTimer = null;
  }
};

const startDownloadCarouselAutoplay = () => {
  stopDownloadCarouselAutoplay();
  downloadCarouselAutoplayTimer = setInterval(() => {
    downloadCarouselActiveIndex.value = normalizeDownloadCarouselIndex(downloadCarouselActiveIndex.value + 1);
  }, 5000);
};

const setDownloadCarouselSlide = (index: number) => {
  downloadCarouselActiveIndex.value = normalizeDownloadCarouselIndex(index);
  startDownloadCarouselAutoplay();
};

const pauseDownloadCarousel = () => {
  stopDownloadCarouselAutoplay();
};

const resumeDownloadCarousel = () => {
  if (!isDownloadCarouselDragging.value) {
    startDownloadCarouselAutoplay();
  }
};

const handleDownloadCarouselPointerDown = (event: PointerEvent) => {
  if (event.pointerType === 'mouse' && event.button !== 0) return;

  isDownloadCarouselDragging.value = true;
  downloadCarouselDragStartX.value = event.clientX;
  downloadCarouselDragDistance.value = 0;
  downloadCarouselDidDrag.value = false;
  pauseDownloadCarousel();

  const carousel = event.currentTarget as HTMLElement;
  carousel.setPointerCapture(event.pointerId);
};

const handleDownloadCarouselPointerMove = (event: PointerEvent) => {
  if (!isDownloadCarouselDragging.value) return;

  downloadCarouselDragDistance.value = event.clientX - downloadCarouselDragStartX.value;
  downloadCarouselDidDrag.value = Math.abs(downloadCarouselDragDistance.value) > 8;
};

const handleDownloadCarouselPointerUp = (event: PointerEvent) => {
  if (!isDownloadCarouselDragging.value) return;

  const dragDistance = downloadCarouselDragDistance.value;
  if (Math.abs(dragDistance) > 40) {
    downloadCarouselActiveIndex.value = normalizeDownloadCarouselIndex(
      downloadCarouselActiveIndex.value + (dragDistance < 0 ? 1 : -1)
    );
  }

  isDownloadCarouselDragging.value = false;
  downloadCarouselDragDistance.value = 0;
  resumeDownloadCarousel();

  const carousel = event.currentTarget as HTMLElement;
  if (carousel.hasPointerCapture(event.pointerId)) {
    carousel.releasePointerCapture(event.pointerId);
  }
};

const handleDownloadCarouselSlideClick = (index: number) => {
  if (downloadCarouselDidDrag.value) {
    downloadCarouselDidDrag.value = false;
    return;
  }

  setDownloadCarouselSlide(index);
};

// Poker Block 滾動動畫相關
const pokerBlockRef = ref<HTMLElement | null>(null);
const linkBlockRef = ref<HTMLElement | null>(null);
const activeCardIndex = ref(1);
const visiblePokerSideIcons = ref(0);
const totalCards = 25;

// 動態匯入所有撲克牌圖片
const cardModules = import.meta.glob('@/assets/img/pokerCards/card*.png', { eager: true, import: 'default' });

// 建立排序後的圖片陣列 (card1 -> card25)
const pokerCardImages = computed(() => {
  const cards: string[] = [];
  for (let i = 1; i <= totalCards; i++) {
    const key = Object.keys(cardModules).find((k) => k.includes(`card${i}.png`));
    if (key) {
      cards.push(cardModules[key] as string);
    }
  }
  return cards;
});

// 先只定位 bonusBg.png 中寶箱上蓋左側的一張牌。
const bonusCardPlacements = [
  { x: 35.5, y: 35, scale: 0.68, depth: 0, rotate: -20, tiltX: 60, blur: 5 },
  { x: 30, y: 35, scale: 0.68, depth: 0, rotate: -30, tiltX: 60, blur: 5 },
  { x: 25, y: 36, scale: 0.68, depth: 0, rotate: -39, tiltX: 60, blur: 5 },
  { x: 21, y: 37, scale: 0.8, depth: 0, rotate: -60, tiltX: 60, blur: 5 },
  { x: 17, y: 39, scale: 0.85, depth: 0, rotate: -70, tiltX: 60, blur: 5 },
  { x: 13, y: 42, scale: 0.95, depth: 0, rotate: -80, tiltX: 60, blur: 5 },
  { x: 13, y: 48, scale: 1.1, depth: 0, rotate: -110, tiltX: 50, blur: 3 },
  { x: 17, y: 52, scale: 1.2, depth: 0, rotate: -135, tiltX: 50, blur: 2 },
  { x: 24, y: 56, scale: 1.4, depth: 0, rotate: -152, tiltX: 47, blur: 1.5 },
  { x: 34, y: 60, scale: 1.6, depth: 0, rotate: -166, tiltX: 47, blur: 1.2 },
  { x: 40, y: 60, scale: 1.6, depth: 0, rotate: -166, tiltX: 47, blur: 1.2 },
];

const bonusCardStyles = computed(() =>
  bonusCardPlacements.map((placement, index) => {
    return {
      '--bonus-card-x': `${placement.x}%`,
      '--bonus-card-y': `${placement.y}%`,
      '--bonus-card-rotate': `${placement.rotate}deg`,
      '--bonus-card-tilt-x': `${placement.tiltX}deg`,
      '--bonus-card-scale': placement.scale.toString(),
      '--bonus-card-depth': `${placement.depth}px`,
      '--bonus-card-blur': `${placement.blur}px`,
      zIndex: index + 1,
    };
  })
);

// 滾動事件處理 - 計算當前應顯示的卡片索引
const handleScroll = () => {
  if (!pokerBlockRef.value || !linkBlockRef.value) return;

  const pokerRect = pokerBlockRef.value.getBoundingClientRect();
  const linkRect = linkBlockRef.value.getBoundingClientRect();
  const viewportHeight = window.innerHeight;

  // 動畫開始點：poker-block 頂部到達視窗 35% 位置
  const animationStartTrigger = viewportHeight * 0.35;
  // 動畫結束點：link-block 中點到達視窗 70% 位置
  const animationEndTrigger = viewportHeight * 0.8;

  // 計算動畫開始和結束的滾動位置
  const startPosition = pokerRect.top; // poker-block 頂部位置
  const endPosition = linkRect.top; // link-block 中點位置 (linkRect.height / 4)

  // 計算進度：
  // 當 startPosition <= animationStartTrigger 時開始 (進度從 0 開始)
  // 當 endPosition <= animationEndTrigger 時結束 (進度到達 1)

  if (startPosition > animationStartTrigger) {
    // 還沒開始動畫
    activeCardIndex.value = 1;
    visiblePokerSideIcons.value = 0;
    return;
  }

  if (endPosition <= animationEndTrigger) {
    // 動畫已結束，保持最後一張
    activeCardIndex.value = totalCards;
    visiblePokerSideIcons.value = 3;
    return;
  }

  // 計算動畫進度
  const currentScrolled = animationStartTrigger - startPosition;
  const progress = Math.max(0, Math.min(1, currentScrolled / (currentScrolled + (endPosition - animationEndTrigger))));

  // 根據進度計算應顯示的卡片索引 (1-25)
  activeCardIndex.value = Math.floor(progress * totalCards) + 1;
  // 側邊圖示依照滾動進度分三階段依序顯示
  visiblePokerSideIcons.value = Math.min(3, Math.ceil(progress * 3));
};

const handleParallaxScroll = () => {
  if (!bannerRef.value) return;

  const scrolled = window.scrollY;
  const parallaxSpeed = 0.5; // 調整這個值來控制視差速度 (0.5 = 背景移動速度是正常的一半)

  // 使用 CSS 變數移動背景層，不影響 banner 內容與入場動畫
  bannerRef.value.style.setProperty('--banner-bg-position-y', `${scrolled * parallaxSpeed}px`);
};

onMounted(() => {
  window.addEventListener('scroll', handleParallaxScroll, { passive: true });
  handleParallaxScroll();
  window.addEventListener('scroll', handleScroll, { passive: true });
  // 初始化時執行一次
  handleScroll();
  startDownloadCarouselAutoplay();
});

onUnmounted(() => {
  window.removeEventListener('scroll', handleScroll);
  window.removeEventListener('scroll', handleParallaxScroll);
  stopDownloadCarouselAutoplay();
});

// 定義模組陣列
const modules = [Navigation, Pagination, Autoplay];

const breakpoints = {
  // 手機 (< 640px)
  320: { spaceBetween: 30 },
  // 平板 (640px+)
  640: { spaceBetween: 30 },
  // 桌面 (1024px+)
  1024: { spaceBetween: 30 },
};

// link-block 和 download-block list-area 專用 breakpoints
// 根據螢幕大小自動調整顯示數量，讓所有 items 填滿畫面
const linkBlockBreakpoints = {
  320: { slidesPerView: 2, spaceBetween: 10, slidesOffsetBefore: 15, slidesOffsetAfter: 15 },
  769: { slidesPerView: 3, spaceBetween: 20, slidesOffsetBefore: 0, slidesOffsetAfter: 0 },
  1024: { slidesPerView: 3, spaceBetween: 30, slidesOffsetBefore: 0, slidesOffsetAfter: 0 },
};

// Swiper 事件處理
const onSwiper = (swiper: any) => {
  console.log('Swiper 初始化', swiper);
};

// const onSlideChange = (swiper: any) => {
//   console.log('滑動到第', swiper.activeIndex, '張');
// };
</script>

<style lang="scss" scoped>
@use '@/assets/css/main.scss' as *;

.index-page.is-en,
.index-page.is-en * {
  letter-spacing: normal !important;
}

.section-wrapper {
  background: url(@/assets/img/blocksBg.png);
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  background-position-y: 0px;
}

.banner-block {
  position: relative;
  isolation: isolate;
  overflow: hidden;
  height: 600px;
  display: flex;
  align-items: center;
  flex-direction: column;
  @media screen and (max-width: $breakpoint-mobile) {
    height: 300px;
  }

  &::before {
    content: '';
    position: absolute;
    inset: 0;
    z-index: 0;
    background: url(@/assets/img/banner01.png);
    background-size: cover;
    background-position: center var(--banner-bg-position-y, center);
    background-repeat: no-repeat;
    transform: translate3d(-5%, 0, 0);
    opacity: 0;
    will-change: transform, opacity;
  }

  &.is-loaded::before {
    animation: banner-background-enter 1.7s cubic-bezier(0.22, 1, 0.36, 1) forwards;
  }

  .banner-text {
    position: relative;
    z-index: 1;
    padding: 60px 0;
    height: 100%;

    > a {
      position: absolute;
      bottom: 60px;
      left: 50%;
      transform: translateX(-50%);
      opacity: 0;
      animation: banner-link-fade-in 0.6s ease 0.6s both;
      transition:
        opacity 0.3s ease,
        transform 0.3s ease,
        box-shadow 0.3s ease,
        filter 0.3s ease;
      will-change: opacity;

      &:hover {
        transform: translateX(-50%) translateY(-4px) scale(1.03);
        opacity: 0.85;
      }
    }

    > div {
      --index: 0;
      &:nth-of-type(2) {
        --index: 1;
      }
      h1 {
        font-size: 49px;
        font-weight: bold;
        letter-spacing: 3px;
        --color: #{$color-white};
        color: $color-white;
        text-shadow: 0 0 18px rgba(0, 0, 0, 0.9);
        @media screen and (max-width: $breakpoint-mobile) {
          font-size: 30px;
          letter-spacing: 3px;
        }
      }
      h5 {
        color: $color-primary;
        letter-spacing: 10px;
        text-align: right;
        --color: #{$color-primary};
        color: $color-primary;
        font-weight: 400;
        @media screen and (max-width: $breakpoint-mobile) {
          letter-spacing: 5px;
          font-size: 15px;
        }
      }

      h1,
      h5 {
        position: relative;
        clip-path: inset(-20% 0);
        animation-name: text-reveal, shimmy;
        animation-duration: 0.65s;
        animation-delay: calc((0.7 + var(--index)) * (0.65s / 3));
        animation-fill-mode: both;
        animation-timing-function: steps(1), ease-out;
      }

      h1:after,
      h5:after {
        content: '';
        position: absolute;
        inset: -20% 0;
        background: $color-bg-blue;
        animation-name: block-reveal;
        animation-duration: 0.65s;
        animation-delay: calc((0.7 + var(--index)) * (0.65s / 3));
        animation-fill-mode: both;
      }
    }

    @keyframes shimmy {
      0% {
        transform: translateX(-1ch);
      }
    }

    @keyframes text-reveal {
      0% {
        color: transparent;
      }

      50%,
      100% {
        color: var(--color);
      }
    }

    @keyframes block-reveal {
      0% {
        transform: translateX(-110%);
      }

      45%,
      55% {
        transform: translateX(0);
      }

      100% {
        transform: translateX(110%);
      }
    }

    @keyframes banner-link-fade-in {
      from {
        opacity: 0;
      }

      to {
        opacity: 1;
      }
    }
  }
}

@keyframes banner-background-enter {
  from {
    transform: translate3d(-5%, 0, 0);
    opacity: 0;
  }

  to {
    transform: translate3d(0, 0, 0);
    opacity: 1;
  }
}

.swiper-slide {
  width: 231px;
}

.list-wrapper {
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  gap: 50px; /* items 之間的固定間距 */
  .swiper-slide {
    display: flex;
    justify-content: center;
  }
}

.list-block {
  padding: 100px 0;
  .list-title {
    margin-bottom: 50px;
    text-align: center;
    h1 {
      color: $color-primary;
      font-size: 40px;
      font-weight: bold;
      margin-bottom: 20px;
      @media screen and (max-width: $breakpoint-mobile) {
        font-size: 30px;
      }
    }
    p {
      font-size: 16px;
      color: $color-white;
      @media screen and (max-width: $breakpoint-mobile) {
        font-size: 15px;
      }
    }
  }
  .list-swiper {
    .swiper-wrapper {
      justify-content: center;
    }
  }
  .feature-swiper {
    :deep(.swiper-button-prev),
    :deep(.swiper-button-next) {
      width: 28px;
      height: 28px;
      color: $color-primary;
      z-index: 5;

      &::after {
        font-size: 24px;
        font-weight: bold;
      }
    }

    @media screen and (min-width: $breakpoint-desktop) {
      :deep(.swiper-button-prev),
      :deep(.swiper-button-next) {
        display: none;
      }
    }
  }
  .list-item {
    min-height: 90px;
    overflow: hidden;
    border-radius: 10px;
    padding: 200px 25px 35px 25px;
    position: relative;
    width: 200px;

    .list-item-img-wrapper {
      img {
        position: absolute;
        left: 50%;
        transform: translateX(-50%);
        &:first-child {
          top: 30px;
          z-index: 1;
        }
        &:nth-child(2) {
          top: 0px;
          transform: translateX(-50%);
        }
      }
    }
    .list-item-text-wrapper {
      p {
        &:first-child {
          font-size: 15px;
          font-weight: bold;
          color: $color-white;
          letter-spacing: 2px;
          text-align: center;
          margin-bottom: 10px;
        }
        &:nth-child(2) {
          font-size: 13px;
          font-weight: lighter;
          text-align: center;
          color: $color-white;
        }
      }
    }
    img {
      transition: transform 0.35s cubic-bezier(0.22, 1, 0.36, 1);
      will-change: transform;
    }
    p {
      transition: $transition-default;
    }
    &:hover {
      img {
        &:first-child {
          transform: translateX(-50%) scale(1.13);
        }
        &:nth-child(2) {
          transform: translateX(-50%) scale(1.2);
        }
      }
      p {
        &:first-child {
          color: $color-primary;
        }
      }
    }
  }
  @media screen and (max-width: $breakpoint-med) {
    padding-bottom: 60px;
  }
}

.bonus-block {
  overflow: visible;
  position: relative;
  .bonus-bg {
    width: 100%;
    display: block;
    position: relative;
    z-index: 0;
    transform: translateY(30px);
    @media screen and (max-width: $breakpoint-xlarge) {
      transform: translateY(0px);
    }
    @media screen and (max-width: $breakpoint-small) {
      transform: scale(1.2);
    }
  }
  .light {
    width: 100%;
    position: absolute;
    top: -30px;
    z-index: 1;
    opacity: 0.7;
    pointer-events: none;
    animation: shimmer 3s ease-in-out infinite;
    @media screen and (max-width: $breakpoint-xlarge) {
      top: 0;
      animation: shimmer-mobile 3s ease-in-out infinite;
    }
  }

  .bonus-cards {
    position: absolute;
    top: 30px;
    right: 0;
    bottom: 0;
    left: 0;
    z-index: 1;
    overflow: hidden;
    perspective: 1200px;
    perspective-origin: center center;
    pointer-events: none;

    @media screen and (max-width: $breakpoint-xlarge) {
      top: 0;
    }
  }

  .bonus-card {
    position: absolute;
    left: var(--bonus-card-x);
    top: var(--bonus-card-y);
    width: clamp(46px, 7vw, 100px);
    height: auto;
    opacity: 0.96;
    visibility: visible;
    transform: translate3d(-50%, -50%, var(--bonus-card-depth)) rotateX(var(--bonus-card-tilt-x))
      rotateZ(var(--bonus-card-rotate)) scale(var(--bonus-card-scale));
    filter: blur(var(--bonus-card-blur));
    transform-origin: center center;
    pointer-events: none;
  }

  /* 閃閃發光動畫 - 桌面版 */
  @keyframes shimmer {
    0% {
      opacity: 0.4;
      transform: scale(1) translateY(-30px);
    }
    50% {
      opacity: 0.7;
      transform: scale(1.04) translateY(-30px);
    }
    100% {
      opacity: 0.4;
      transform: scale(1) translateY(-30px);
    }
  }

  /* 閃閃發光動畫 - 手機版 */
  @keyframes shimmer-mobile {
    0% {
      opacity: 0.4;
      transform: scale(1) translateY(0px);
    }
    50% {
      opacity: 0.7;
      transform: scale(1.04) translateY(0px);
    }
    100% {
      opacity: 0.4;
      transform: scale(1) translateY(0px);
    }
  }
  .bonus-content {
    width: $breakpoint-mobile;
    position: absolute;
    top: 60%;
    left: 50%;
    transform: translate(-50%, -50%);
    z-index: 1;
    isolation: isolate;
    display: flex;
    flex-direction: column;
    align-items: center;

    &::before {
      content: '';
      position: absolute;
      top: 50%;
      left: 50%;
      z-index: -1;
      width: calc(100% + 120px);
      height: calc(100% + 48px);
      transform: translate(-50%, -50%);
      background: linear-gradient(
        90deg,
        rgba(0, 0, 0, 0) 0%,
        rgba(0, 0, 0, 0.45) 18%,
        rgba(0, 0, 0, 0.45) 82%,
        rgba(0, 0, 0, 0) 100%
      );
      pointer-events: none;
    }

    h2 {
      font-size: 40px;
      font-weight: bold;
      letter-spacing: 8px;
      color: $color-white;
      text-shadow: 0 0 18px rgba(0, 0, 0, 0.9);
      margin-bottom: 20px;
      text-align: center;
      @media screen and (max-width: $breakpoint-med) {
        font-size: 30px;
        letter-spacing: 5px;
        margin-bottom: 5px;
      }
      @media screen and (max-width: $breakpoint-mobile) {
        font-size: 20px;
        letter-spacing: 5px;
        margin-bottom: 5px;
      }
    }
    p {
      color: $color-white;
      text-align: center;
      font-weight: lighter;
      @media screen and (max-width: $breakpoint-mobile) {
        font-size: 13px;
        width: 300px;
      }
    }
    .bonus-link-wrapper {
      position: absolute;
      bottom: -80px;
      left: 50%;
      transform: translateX(-50%);
      @media screen and (max-width: $breakpoint-mobile) {
        bottom: -40px;
      }
    }
    .bonus-link-animation {
      display: inline-block;
    }
    a {
      @media screen and (max-width: $breakpoint-mobile) {
        font-size: 12px;
        padding: 7px 17px;
      }
    }
    @media screen and (max-width: $breakpoint-xlarge) {
      top: 50%;
    }
  }
}

.poker-block {
  position: relative;
  .poker-side-icon {
    position: absolute;
    z-index: 0;
    pointer-events: none;
    opacity: 1;
    transform: translate3d(0, 0, 0);
    will-change: opacity, transform;

    &.black-icon {
      top: 8%;
      left: 0;
      width: clamp(62px, 13.5vw, 137px);
      --poker-icon-start-x: -120vw;
      --poker-icon-start-rotate: -540deg;
    }
    &.money-icon {
      top: 33%;
      right: 0;
      width: clamp(70px, 15vw, 155px);
      --poker-icon-start-x: 120vw;
      --poker-icon-start-rotate: 540deg;
    }
    &.dice-icon {
      top: 72%;
      left: 0;
      width: clamp(110px, 23vw, 241px);
      --poker-icon-start-x: -120vw;
      --poker-icon-start-rotate: -540deg;
    }
  }

  .poker-icon-enter-active {
    transform-origin: center center;
    animation: poker-icon-roll-in 1.1s cubic-bezier(0.22, 1, 0.36, 1) both;
  }

  .poker-icon-leave-active {
    transform-origin: center center;
    animation: poker-icon-roll-out 0.9s cubic-bezier(0.55, 0, 0.78, 0.22) both;
  }

  .poker-icon-enter-from,
  .poker-icon-leave-to {
    opacity: 0;
  }

  @keyframes poker-icon-roll-in {
    0% {
      opacity: 0;
      transform: translate3d(var(--poker-icon-start-x), 0, 0) rotate(var(--poker-icon-start-rotate)) scale(0.45);
    }
    42% {
      opacity: 1;
    }
    100% {
      opacity: 1;
      transform: translate3d(0, 0, 0) rotate(0deg) scale(1);
    }
  }

  @keyframes poker-icon-roll-out {
    0% {
      opacity: 1;
      transform: translate3d(0, 0, 0) rotate(0deg);
    }
    100% {
      opacity: 0;
      transform: translate3d(var(--poker-icon-start-x), 0, 0) rotate(var(--poker-icon-start-rotate));
    }
  }

  .poker-sticky-container {
    position: sticky;
    top: 0;
    height: 1600px;
    display: flex;
    justify-content: center;
    align-items: flex-end;
    overflow: hidden;
    @media screen and (max-width: $breakpoint-desktop) {
      height: 1300px;
    }
    @media screen and (max-width: $breakpoint-xlarge) {
      height: 1200px;
    }
    @media screen and (max-width: $breakpoint-largemMed) {
      height: 900px;
    }
    @media screen and (max-width: $breakpoint-small) {
      height: 600px;
    }
    @media screen and (max-width: $breakpoint-smaller) {
      height: 500px;
    }
  }

  .poker-cards-wrapper {
    position: relative;
    width: 100%;
    height: 1600px;
    display: flex;
    justify-content: center;
    align-items: center;
    @media screen and (max-width: $breakpoint-desktop) {
      height: 1300px;
    }
    @media screen and (max-width: $breakpoint-xlarge) {
      height: 1200px;
    }
    @media screen and (max-width: $breakpoint-largemMed) {
      height: 900px;
    }
    @media screen and (max-width: $breakpoint-small) {
      height: 600px;
    }
    @media screen and (max-width: $breakpoint-smaller) {
      height: 500px;
    }
  }

  .poker-card {
    position: absolute;
    object-fit: contain;
    opacity: 0;
    visibility: hidden;
    pointer-events: none;
    top: 60px;
    @media screen and (max-width: $breakpoint-desktop) {
      top: 40px;
    }

    &.active {
      opacity: 1;
      visibility: visible;
    }
  }
}

.link-block {
  position: relative;
  padding: 100px 0;
  :deep(.swiper-wrapper) {
    justify-content: flex-start;
  }
  .list-item {
    min-height: 90px;
    overflow: hidden;
    padding: 260px 25px 35px 25px;
    position: relative;
    @media screen and (max-width: $breakpoint-mobile) {
      padding: 150px 25px 35px 25px;
    }
    .list-item-img-wrapper {
      img {
        position: absolute;
        left: 50%;
        transform: translateX(-50%);
        &:first-child {
          top: 30px;
          z-index: 1;
          width: 215px;
          @media screen and (max-width: $breakpoint-mobile) {
            width: 100px;
          }
        }
        &:nth-child(2) {
          top: 0px;
          transform: translateX(-50%);
          width: 100%;
          z-index: -1;
        }
      }
    }
    .list-item-text-wrapper {
      z-index: 99;
      p {
        font-size: 22px;
        font-weight: bold;
        color: $color-white;
        text-align: center;
        margin-bottom: 10px;
        z-index: 99;
        @media screen and (max-width: $breakpoint-med) {
          font-size: 18px;
        }
        @media screen and (max-width: $breakpoint-mobile) {
          font-size: 16px;
        }
      }
      a {
        position: absolute;
        left: 50%;
        transform: translateX(-50%);
        bottom: 30px;
        letter-spacing: 1px;
        @media screen and (max-width: $breakpoint-med) {
          font-size: 12px;
        }
        @media screen and (max-width: $breakpoint-mobile) {
          // padding: 4px;
        }
      }
    }
  }
  .ellipse {
    position: absolute;
    left: -100px;
    top: -200px;
    z-index: -1;
  }
  .ellipse-2 {
    position: absolute;
    right: -80px;
    bottom: -400px;
    z-index: -1;
    @media screen and (max-width: $breakpoint-mobile) {
      right: -80px;
      bottom: -200px;
    }
  }
  .greenbox {
    position: absolute;
    right: 80px;
    top: -50px;
    z-index: 99;
    filter: drop-shadow(0 0 8px rgba(255, 255, 255, 0.65)) drop-shadow(0 0 22px rgba(255, 255, 255, 0.28));
    will-change: transform, filter;

    &[data-aos='greenbox-scale'] {
      opacity: 0;
      transform: scale(0.4);

      &.aos-animate {
        animation:
          greenbox-scale-in 1.2s cubic-bezier(0.22, 1, 0.36, 1) both,
          greenbox-idle-rotate 5.2s ease-in-out 1.2s infinite;
      }
    }

    @media screen and (max-width: $breakpoint-mobile) {
      right: 0;
      width: 100px;
      top: 20px;
    }
  }

  @keyframes greenbox-scale-in {
    0% {
      opacity: 0;
      transform: scale(0.4) rotate(-20deg);
    }
    100% {
      opacity: 1;
      transform: scale(1) rotate(0deg);
    }
  }

  @keyframes greenbox-idle-rotate {
    0% {
      transform: translate3d(0, 0, 0) rotate(0deg) rotateX(0deg) rotateY(0deg);
      filter: drop-shadow(0 0 8px rgba(255, 255, 255, 0.65)) drop-shadow(0 0 22px rgba(255, 255, 255, 0.28));
    }
    13% {
      transform: translate3d(2px, -1px, 0) rotate(4deg) rotateX(3deg) rotateY(-5deg);
      filter: drop-shadow(0 0 11px rgba(255, 255, 255, 0.78)) drop-shadow(0 0 28px rgba(255, 255, 255, 0.34));
    }
    29% {
      transform: translate3d(-2px, 1px, 0) rotate(-6deg) rotateX(-4deg) rotateY(4deg);
      filter: drop-shadow(0 0 15px rgba(255, 255, 255, 0.92)) drop-shadow(0 0 36px rgba(255, 255, 255, 0.46));
    }
    47% {
      transform: translate3d(1px, 0, 0) rotate(3deg) rotateX(5deg) rotateY(6deg);
      filter: drop-shadow(0 0 7px rgba(255, 255, 255, 0.58)) drop-shadow(0 0 18px rgba(255, 255, 255, 0.22));
    }
    63% {
      transform: translate3d(-1px, -2px, 0) rotate(-4deg) rotateX(-3deg) rotateY(-6deg);
      filter: drop-shadow(0 0 13px rgba(255, 255, 255, 0.86)) drop-shadow(0 0 31px rgba(255, 255, 255, 0.4));
    }
    81% {
      transform: translate3d(2px, 1px, 0) rotate(5deg) rotateX(4deg) rotateY(3deg);
      filter: drop-shadow(0 0 9px rgba(255, 255, 255, 0.7)) drop-shadow(0 0 24px rgba(255, 255, 255, 0.3));
    }
    100% {
      transform: translate3d(0, 0, 0) rotate(0deg) rotateX(0deg) rotateY(0deg);
      filter: drop-shadow(0 0 8px rgba(255, 255, 255, 0.65)) drop-shadow(0 0 22px rgba(255, 255, 255, 0.28));
    }
  }
}

.download-block {
  background: url(@/assets/img/downloadBg.png);
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  padding-bottom: 70px;
  .slider-area {
    display: flex;
    align-items: center;
    @media only screen and (max-width: $breakpoint-med) {
      display: block;
    }
    > div:first-child {
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: column;
      padding-top: 80px;
      @media screen and (max-width: $breakpoint-med) {
        padding-top: 0px;
      }
    }
    .slider-swiper-wrapper {
      direction: ltr;
      background: url(@/assets/img/swiperBg.png);
      align-self: stretch;
      display: flex;
      align-items: center;
      background-position: center;
      background-repeat: no-repeat;
      background-size: cover;
      padding: 20px 30px;
      position: relative;
      overflow: hidden;

      .download-carousel {
        position: relative;
        height: 100%;
        width: 100%;
        min-height: 360px;
        overflow: hidden;
        touch-action: pan-y;
        user-select: none;
        cursor: grab;

        &:active {
          cursor: grabbing;
        }
      }

      .download-carousel-stage {
        position: relative;
        height: 100%;
        min-height: inherit;
        transform: translate3d(0, 0, 0);
        transition: transform 0.35s ease;

        &.is-dragging {
          cursor: grabbing;
          transition: none;
        }
      }

      .download-carousel-slide {
        position: absolute;
        top: 50%;
        left: 50%;
        width: clamp(120px, 42vw, 320px);
        margin: 0;
        padding: 0;
        border: 0;
        background: transparent;
        line-height: 0;
        cursor: pointer;
        transform: translate(-50%, -50%) scale(0.58) rotateY(26deg);
        opacity: 0.3;
        filter: brightness(0.25);
        transition:
          transform 0.45s ease,
          opacity 0.45s ease,
          filter 0.45s ease;

        img {
          display: block;
          width: 100%;
          height: auto;
          pointer-events: none;
        }

        &.is-carousel-active {
          z-index: 5;
          transform: translate(-50%, -50%) scale(1) rotateY(0deg);
          opacity: 1;
          filter: brightness(1);
        }

        &.is-carousel-left,
        &.is-carousel-right {
          z-index: 3;
          opacity: 0.58;
          filter: brightness(0.42);
        }

        &.is-carousel-left {
          transform: translate(-50%, -50%) translateX(-125px) scale(0.8) rotateY(18deg);
        }

        &.is-carousel-right {
          transform: translate(-50%, -50%) translateX(125px) scale(0.8) rotateY(-18deg);
        }

        &.is-carousel-far-left,
        &.is-carousel-far-right {
          z-index: 1;
        }

        &.is-carousel-far-left {
          transform: translate(-50%, -50%) translateX(-210px) scale(0.58) rotateY(26deg);
        }

        &.is-carousel-far-right {
          transform: translate(-50%, -50%) translateX(210px) scale(0.58) rotateY(-26deg);
        }
      }

      .download-carousel-pagination {
        position: absolute;
        right: 0;
        bottom: 12px;
        left: 0;
        z-index: 10;
        display: flex;
        justify-content: center;
        gap: 5px;
      }

      .download-carousel-dot {
        width: 7px;
        height: 7px;
        padding: 0;
        border: 0;
        border-radius: 50%;
        background: rgba(255, 255, 255, 0.45);
        cursor: pointer;
        transition: all 0.3s ease;

        &.is-active {
          background: $color-white;
          transform: scale(1.35);
        }
      }

      @media screen and (min-width: $breakpoint-med) and (max-width: $breakpoint-large) {
        .download-carousel-slide {
          width: 200px;
        }
      }

      @media screen and (max-width: $breakpoint-med) {
        padding: 15px 20px;

        .download-carousel {
          min-height: 320px;
        }

        .download-carousel-slide {
          width: clamp(110px, 42vw, 200px);

          &.is-carousel-left {
            transform: translate(-50%, -50%) translateX(-100px) scale(0.78) rotateY(18deg);
          }

          &.is-carousel-right {
            transform: translate(-50%, -50%) translateX(100px) scale(0.78) rotateY(-18deg);
          }

          &.is-carousel-far-left {
            transform: translate(-50%, -50%) translateX(-175px) scale(0.56) rotateY(26deg);
          }

          &.is-carousel-far-right {
            transform: translate(-50%, -50%) translateX(175px) scale(0.56) rotateY(-26deg);
          }
        }
      }
    }
    p {
      font-size: 30px;
      font-weight: bold;
      text-align: center;
      margin-bottom: 30px;
      @media screen and (max-width: $breakpoint-med) {
        font-size: 24px;
      }
    }
  }
  .list-area {
    margin-top: 100px;
    .list-swiper {
      :deep(.swiper-wrapper) {
        justify-content: flex-start !important;
      }
    }
    .list-item {
      min-height: 90px;
      overflow: hidden;
      padding: 260px 25px 35px 25px;
      position: relative;
      @media screen and (max-width: $breakpoint-mobile) {
        padding: 100px 15px 35px 15px;
      }
      .list-item-img-wrapper {
        img {
          position: absolute;
          left: 50%;
          transform: translateX(-50%);
          &:first-child {
            top: 30px;
            z-index: 1;
            @media screen and (max-width: $breakpoint-mobile) {
              top: 20px;
              width: 60px;
            }
          }
          &:nth-child(2) {
            top: 5px;
            transform: translateX(-50%);
            @media screen and (max-width: $breakpoint-mobile) {
              top: -10px;
            }
          }
        }
      }
      .list-item-text-wrapper {
        position: relative;
        z-index: 999;
        p {
          &:first-child {
            font-size: 15px;
            font-weight: bold;
            color: $color-white;
            letter-spacing: 2px;
            text-align: center;
            margin-bottom: 10px;
          }
          &:nth-child(2) {
            font-size: 13px;
            font-weight: lighter;
            text-align: center;
            color: $color-white;
          }
        }
      }
      img {
        transition: transform 0.35s cubic-bezier(0.22, 1, 0.36, 1);
        will-change: transform;
      }
      p {
        transition: $transition-default;
      }
      &:hover {
        img {
          &:first-child {
            transform: translateX(-50%) scale(1.1);
          }
          &:nth-child(2) {
            transform: translateX(-50%) scale(1.1);
          }
        }
        p {
          &:first-child {
            color: $color-primary;
          }
        }
      }
    }
  }
}
</style>
